import React from 'react'

import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { PageWrapper } from './style'

const MissionPageWrapper = ({ children }) => (
  <HideWhenBlocked>
    <PageWrapper>{children}</PageWrapper>
  </HideWhenBlocked>
)

export { MissionPageWrapper }
